import axios from './axiosInstance';

export default {
  // Create Instruction
  createInstruction(instructionData) {
    return axios.post('/instructions/', instructionData);
  },

  // Read Instructions
  getInstructions(page = 1, size = 10) {
    return axios.get('/instructions/', {
      params: { page, size },
    });
  },

  // Search Instructions
  searchInstructions(query, page, size) {
    return axios.get('/instructions/search', {
      params: { query ,page , size},
    });
  },

  // Fetch Instruction by ID
  getInstructionById(instructionId) {
    return axios.get(`/instructions/${instructionId}`);
  },  

  // Update Instruction
  updateInstruction(instructionId, instructionData) {
    return axios.put(`/instructions/${instructionId}`, instructionData);
  },

  // Delete Instruction
  deleteInstruction(instructionId) {
    return axios.delete(`/instructions/${instructionId}`);
  },
};
